import SockJS from 'sockjs-client';
import Stomp from 'webstomp-client'
import { config } from '../_helpers/config';
import { useUsersStore } from '@/stores/users'
let stompClient = null;
let mainConfig = config.apiUrl
let sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
export function connectWebSocket() {
  console.log(mainConfig);
  
  const socket = new SockJS(`${mainConfig}ws?access_token=${localStorage.getItem("access_token")}`)
  stompClient = Stomp.over(socket);
  stompClient.subscribe = awaitDecorator(stompClient.subscribe)
  stompClient.connect({}, () => {
    stompClient.subscribe('/topic/profileEditing', (message) => {
      if (message.body) {
        useUsersStore().updateUserProfile(message.body)
        console.log(message.body);
      }
    });
    stompClient.subscribe('/topic/checkEditingProfile', (message) => {
      if (message.body) {
        useUsersStore().checkUpdatedUserProfile(message.body)
        console.log(message.body);
      }
    });
  }, (error) => {
    console.error('WebSocket error:', error);
  });

  socket.onclose = () => {
    setTimeout(() => {
      connectWebSocket()
    }, 30000)
  }
}
let awaitDecorator = (f) => {
  return async function () {
    if (stompClient.connected) return f.apply(this, arguments)
    await sleep(300)
    return f.apply(this, arguments)
  }
}
export function disconnectWebSocket() {
    console.log(312);
    
  if (stompClient !== null) {
    stompClient.disconnect();
  }
}